<template>
    <div
        v-if="componentStyles"
        :style="componentStyles"
        :class="['o-keyboard-standard', { 'keyboard-standard-minimise': minimise}]"
    >
        <div class="keyboard-standard-wrapper">
            <div
                class="keyboard-standard-input-wrapper"
                @click="minimiseKeyboard"
            >
                <div
                    v-if="isCategorySelected"
                    class="keyboard-standard-category"
                >
                    {{ categoryName }}
                </div>
                <input
                    v-model="value"
                    type="text"
                    class="keyboard-standard-input"
                    ref="fuseSearchInput"
                    disabled
                    :placeholder="inputPlaceholder"
                />
                <button
                    v-if="inputRemoveButton"
                    type="button"
                    class="keyboard-standard-button"
                    @click="removeValue"
                >
                    <span class="keyboard-standard-input-button-placeholder">
                        {{removeButtonText}}
                    </span>
                </button>
            </div>
            <div
                v-if="!minimise"
                class="keyboard-standard-letters-wrapper"
            >
                <div
                    v-for="(row, index) in characters"
                    :key="index"
                    class="keyboard-standard-row"
                >
                    <OKeyboardKey
                        v-for="key in row"
                        :key="key"
                        :keyboard-key-value="key"
                        @onClickEvent="onClickKey"
                    />
                </div>
                <div class="keyboard-standard-row keyboard-bottom-row">
                    <OKeyboardKey
                        :keyboard-key-value="$t('ui.delete')"
                        class="button-bottom-row"
                        click-event="onRemoveValue"
                        @onRemoveValue="removeValue"
                    />
                    <OKeyboardKey
                        keyboard-key-value=" "
                        class="button-bottom-row"
                        @onClickEvent="onClickKey"
                    >
                        <span>{{ $t('ui.space-key') }}</span>
                    </OKeyboardKey>
                    <OKeyboardKey
                        :keyboard-key-value="textSymbolsButton"
                        class="button-bottom-row"
                        @onClickEvent="handleChangeCharacters"
                    />
                </div>
            </div>
        </div>
        <template>
            <ATextButton
                v-if="isTextHideButtonRender"
                :text="$t('ui.close')"
                :icon="backButtonIconName"
                class="close-button"
                @onClick="collapseKeyboard"
            />
            <button
                v-if="!isTextHideButton"
                type="button"
                :class="['keyboard-standard-hide-button', {'keyboard-standard-hide-button-hide-button-expand': minimise}]"
                @click="switchKeyboardState"
            />
        </template>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";

import ATextButton from '../../atoms/a-text-button';
import OKeyboardKey from '../../organisms/o-keyboard-key';

import { KEYBOARD_CHARACTERS } from "./constants";
import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: "OKeyboardStandard",
    data() {
        return {
            value: '',
            minimise: false,
            type: 'symbols'
        }
    },
    components: {
        ATextButton,
        OKeyboardKey
    },
    props: {
        view: {
            type: String,
            default: ''
        }
        // selectedCategoryId: {
        //     type: Number,
        //     default: null
        // }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            't',
            'getListItem',
            'getMapConfigProp',
            'getTenantCategoriesRoot'
        ]),
        characters() {
            return KEYBOARD_CHARACTERS[this.locale]?.[this.type] || KEYBOARD_CHARACTERS['en'][this.type];
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OKeyboardStandard.styles`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OKeyboardStandard.styles') || {};
        },
        componentStyles() {
            return {
                ...this.viewConfigStyles,
                ...this.commonConfigStyles
            }
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OTilesGridWithScroll.params.OKeyboardStandard.params`) || {};
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OKeyboardStandard.params') || {};
        },
        componentParams() {
            return {
                ...this.viewConfigParams,
                ...this.commonConfigParams
            }
        },
        isTextHideButton() {
            return this.componentParams?.textHideButton || false;
        },
        isTextHideButtonRender() {
            return this.isTextHideButton && !this.minimise;
        },
        isCategorySelected() {
            return this.getTenantCategoriesRoot.id !== this.selectedCategoryId;
        },
        categoryName() {
            return this.t(this.getListItem(this.selectedCategoryId), 'name') + " / ";
        },
        inputPlaceholder() {
            return this.$t(this.componentParams.placeholder) || this.$t('ui.search.placeholder');
        },
        inputRemoveButton() {
            return this.componentParams.inputRemoveButton ?? true;
        },
        textSymbolsButton() {
            return this.type === 'symbols' ? '123' : 'ABC';
        },
        selectedCategoryId() {
            return +this.$route.params.categoryId;
        },
        backButtonIconName() {
            return this.componentParams.back_button_icon_name || 'close-black'
        },
        removeButtonText() {
            return this.componentParams.remove_button_text || this.$t('Delete')
        }
    },
    methods: {
        onClickKey(value) {
            if (this.value.length < 25) {
                this.value += value.toUpperCase();
                this.$emit('changeSearchValue', this.value)

                this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.CHANGE_SEARCH_QUERY, this.value);
            }
        },
        removeValue() {
            this.value = this.value.substring(0, this.value.length - 1);
            this.$emit('changeSearchValue', this.value);
            this.$emit('removeValue');

            this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.CHANGE_SEARCH_QUERY, this.value);
            this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.REMOVE_VALUE);
        },
        switchKeyboardState() {
            this.minimise = !this.minimise;
            this.$emit('keyboardChangeState', this.minimise);

            this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.CLOSE_KEYBOARD);
        },
        minimiseKeyboard() {
            this.minimise = false;
        },
        collapseKeyboard() {
            this.minimise = true;

            this.$bus.$emit(EVENTS.KEYBOARD_STANDARD.CLOSE_KEYBOARD);
        },
        handleChangeCharacters() {
            if (this.type === 'symbols') this.type = 'numbers';
            else this.type = 'symbols';
        }
    },
    activated() {
        this.value = '';
    }
}
</script>

<style lang="scss" src="./theme.scss" />
